// extracted by mini-css-extract-plugin
export default {"subpageSidebarCollapsed":"dashboardContent_subpageSidebarCollapsed__q9d2v","subpage":"dashboardContent_subpage__27X1b"};